import { useMemo } from 'react';

import { useSystemAutomation } from '../contexts/system-automation-context';
import { InsuranceProviders } from '../enums/insurance-providers';
import { ACTION_TYPE_INSURE_PACKAGE } from '../pages/settings/automation-rules/constants/action-types';
import type { AutomationRule } from '../pages/settings/automation-rules/types/automation-rule-types';

// XCover and ParcelGuard are regionally equivalent insurance products, so either one should trigger the ParcelGuard UI treatment.
const MATCHING_PROVIDER_IDS = [
  Number.parseInt(InsuranceProviders.ParcelGuard.insuranceProviderId, 10),
  Number.parseInt(InsuranceProviders.XCover.insuranceProviderId, 10),
];

export const useHasParcelGuardAutomationRule = (): boolean => {
  const { automationRules } = useSystemAutomation() as { automationRules?: unknown };

  return useMemo(() => {
    const rules: AutomationRule[] = Array.isArray(automationRules) ? automationRules : [];
    return rules.some(
      (rule) =>
        rule.active &&
        rule.orderRuleActions?.some(
          (action) =>
            action.actionTypeId === ACTION_TYPE_INSURE_PACKAGE &&
            action.intParameter != null &&
            MATCHING_PROVIDER_IDS.includes(action.intParameter) &&
            !action.isDeleted,
        ),
    );
  }, [automationRules]);
};
